import { legacy_createStore as createEnhancedStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import * as Sentry from '@sentry/react';
import appConfig from './appConfig';
import { createRootReducer, rootSaga, history } from '../core/modules';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createReduxStore = () => {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [sagaMiddleware];

    const routerMiddle: any = routerMiddleware(history);
    middlewares.push(routerMiddle);

    let composeEnhancer = compose;
    const sentryReduxEnhancer = appConfig.useSentry
        ? Sentry.createReduxEnhancer({
              stateTransformer: (state) => {
                  // Clone the state and customize currentBooking
                  return {
                      ...state,
                      currentBooking: {
                          ...state.currentBooking,
                          costCenter: JSON.stringify(state.currentBooking.costCenter),
                          currentPosition: JSON.stringify(state.currentBooking.currentPosition),
                          // Keep id + name for debugging; strip phone_number / email (PII) before sending to Sentry
                          passengers: JSON.stringify(
                              (state.currentBooking.passengers ?? []).map((passenger: any) => ({
                                  id: passenger?.id,
                                  firstname: passenger?.firstname,
                                  lastname: passenger?.lastname,
                              })),
                          ),
                          payment: JSON.stringify(state.currentBooking.payment),
                          quote: JSON.stringify(state.currentBooking.quote),
                          poi: JSON.stringify(state.currentBooking.poi),
                          poiMeetingPoint: JSON.stringify(state.currentBooking.poiMeetingPoint),
                          recurrence: JSON.stringify(state.currentBooking.recurrence),
                          stops: JSON.stringify(state.currentBooking.stops),
                      },
                  };
              },
          })
        : null;

    if (appConfig.isDev) {
        // deactivate eslint rule so that it doesn't complain from 'requires' below
        /* eslint global-require: 0 */
        if (appConfig.useReduxDevTools) {
            composeEnhancer = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        }

        if (appConfig.useReduxLogger) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const createLoggerMiddleware = require('./reduxDevLogger').default;
            middlewares.push(createLoggerMiddleware());
        }
    }

    const store = createEnhancedStore(
        createRootReducer(),
        sentryReduxEnhancer
            ? composeEnhancer(applyMiddleware(...middlewares), sentryReduxEnhancer)
            : composeEnhancer(applyMiddleware(...middlewares)),
    );

    sagaMiddleware.run(rootSaga);
    return store;
};

export default {
    createReduxStore,
};
